import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { environment } from '../../environments/environment';

let HOST = environment.apiHost;

@Injectable()
export class NewReleaseService {


    constructor(private http: Http, private httpClient:HttpClient) { }


    // send release data
    sendRelease(param, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };
        
        const requestBody = {
            version: param.version,
            project: param.project,
            component: param.component,
            fileName: param.fileName,
            owner: param.owner,
            desc: param.desc,
            destination: param.destination,
            note: param.note,
            relaseNote: param.relaseNote,
            test: param.test,
            testCases: param.testCases,
            uploaded_by: param.uploaded_by,
            workflow: param.workflow,
            qa: param.qa,
            skipComment: param.skipComment,
            cc: param.cc
        };

        return this.httpClient.post(HOST + '/send', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('project', param.project);
        // params.set('component', param.component);
        // params.set('version', param.version);
        // params.set('owner', param.owner);
        // params.set('qa', param.qa);
        // params.set('desc', param.desc);
        // params.set('fileName', param.fileName);
        // params.set('destination', param.destination);
        // params.set('note', param.note);
        // params.set('relaseNote', param.relaseNote);
        // params.set('test', param.test);
        // params.set('testCases', param.testCases);
        // params.set('uploaded_by', param.uploaded_by);
        // params.set('workflow', param.workflow);
        // params.set('skipComment', param.skipComment);
        // params.set('cc', param.cc);

        // return this.http.post(HOST + '/send', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    sendActivity(param, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            file: param.file,
            action: param.action,
            user: param.user
        };

        return this.httpClient.post(HOST + '/send_activity', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('file', param.file);
        // params.set('action', param.action);
        // params.set('user', param.user);

        // return this.http.post(HOST + '/send_activity', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    getLastVersionForComponentTest(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            component: param.component
        };

        return this.httpClient.post(HOST + '/last-component-version', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);


    }


    getLastVersionForComponent(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            component: param.component
        };

        return this.httpClient.post(HOST + '/last-version', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);


    }


    sendReleaseEmail(param, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            fromEmail: param.fromEmail,
            fromUser: param.fromUser,
            toEmail: param.toEmail,
            toUser: param.toUser,
            subject: param.subject,
            version: param.version,
            project: param.project,
            cc: param.cc,
            component: param.component,
            desc: param.desc,
            index: param.index
        };

        return this.httpClient.post(HOST + '/email', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('fromEmail', param.fromEmail);
        // params.set('fromUser', param.fromUser);
        // params.set('toEmail', param.toEmail);
        // params.set('toUser', param.toUser);
        // params.set('subject', param.subject);
        // params.set('version', param.version);
        // params.set('project', param.project);
        // params.set('cc', param.cc);
        // params.set('component', param.component);
        // params.set('desc', param.desc);
        // params.set('index', param.index);

        // return this.http.post(HOST + '/email', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }


}
